import { useSnackbar } from "notistack";
import { useFeliz_React__React_useDeferred_Static_2344FC52 } from "../fable_modules/Feliz.UseDeferred.1.5.0/UseDeferred.fs.js";
import { DossierKind, CommentType, DossierCode } from "../../../shared/Domain.fs.js";
import { useReact_useEffect_Z101E1A95, useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.68.0/React.fs.js";
import { PagingQuery } from "../../../shared/Paging.fs.js";
import { ofArray, empty } from "../fable_modules/fable-library.3.7.17/List.js";
import { startImmediate } from "../fable_modules/fable-library.3.7.17/Async.js";
import { singleton } from "../fable_modules/fable-library.3.7.17/AsyncBuilder.js";
import { EnqueueSnackbarOption, SnackbarProp_Variant_Z609E1E86, ProviderContext__enqueueSnackbar_Z1776A768 } from "../../../Notistack/Notistack.fs.js";
import { equals } from "../fable_modules/fable-library.3.7.17/Util.js";
import { createElement } from "react";
import { Page } from "../components/Page.fs.js";
import { ErrorText, Card } from "../../../DesignSystems/DesignSystem.fs.js";
import { DisplayDeferred } from "../../../DesignSystems/DisplayDeferred.fs.js";
import { EditDossierStepperPage } from "../../../DesignSystems/dossier/DossierEdit.fs.js";
import { Page$2__toUrl_2B594 } from "../../../BidirectionalRouting/BidirectionalRouting.fs.js";
import { dossierDetail, customerDetail } from "../AppRoutes.fs.js";
import { printf, toConsole } from "../fable_modules/fable-library.3.7.17/String.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.3.10.0/./Router.fs.js";
import { DossierCreatePageSource } from "../../../DesignSystems/DossierUtils.fs.js";

export function DossierEdit(dossierEditInputProps) {
    let dossier_1;
    const dossierCode = dossierEditInputProps.dossierCode;
    const api = dossierEditInputProps.api;
    const currentPage = dossierEditInputProps.currentPage;
    const snackbar = useSnackbar();
    const data = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetDossierDetails(new DossierCode(dossierCode)), []);
    const pageNumber = useFeliz_React__React_useState_Static_1505(0)[0] | 0;
    const pageSize = useFeliz_React__React_useState_Static_1505(2147483647)[0] | 0;
    const partners = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetPartnersAndSyndics(new PagingQuery(pageNumber, pageSize), void 0), [pageNumber, pageSize]);
    const patternInput_2 = useFeliz_React__React_useState_Static_1505(void 0);
    const setCustomer = patternInput_2[1];
    const customer = patternInput_2[0];
    const customers = useFeliz_React__React_useDeferred_Static_2344FC52(api.GetCustomers(new PagingQuery(0, 2147483647), void 0), []);
    const patternInput_3 = useFeliz_React__React_useState_Static_1505(void 0);
    const patternInput_4 = useFeliz_React__React_useState_Static_1505(void 0);
    const partnerId = patternInput_4[0];
    const patternInput_5 = useFeliz_React__React_useState_Static_1505(empty());
    const patternInput_6 = useFeliz_React__React_useState_Static_1505(new CommentType(0));
    const commentType = patternInput_6[0];
    const pageNumber_1 = 0;
    const pageSize_1 = 2147483647;
    const dossierCode_1 = new DossierCode(dossierCode);
    useReact_useEffect_Z101E1A95(() => {
        startImmediate(singleton.Delay(() => singleton.Bind(api.GetDossierComments(dossierCode_1, new PagingQuery(pageNumber_1, pageSize_1), commentType), (_arg_2) => {
            const comments_1 = _arg_2;
            if (comments_1.tag === 0) {
                patternInput_5[1](comments_1.fields[0].Data);
                return singleton.Zero();
            }
            else {
                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een onbekende fout is opgetreden. Gelieve support te contacteren.", SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                return singleton.Zero();
            }
        })));
    }, [commentType]);
    useReact_useEffect_Z101E1A95(() => {
        startImmediate(singleton.Delay(() => singleton.Bind(api.GetPartnersAndSyndics(new PagingQuery(pageNumber_1, pageSize_1), void 0), (_arg) => {
            const partners_2 = _arg;
            if (partners_2.tag === 1) {
                const err = partners_2.fields[0];
                console.error(err);
                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                return singleton.Zero();
            }
            else {
                patternInput_3[1](partners_2.fields[0].Data);
                return singleton.Zero();
            }
        })));
    }, [pageNumber_1, pageSize_1]);
    useReact_useEffect_Z101E1A95(() => {
        startImmediate(singleton.Delay(() => {
            if (partnerId == null) {
                return singleton.Zero();
            }
            else {
                const partnerId_1 = partnerId;
                return singleton.Bind(api.GetCustomerOfPartner(partnerId_1), (_arg_7) => {
                    const customer_3 = _arg_7;
                    if (customer_3.tag === 1) {
                        const err_4 = customer_3.fields[0];
                        return singleton.Combine((err_4.indexOf("Krijg klant") >= 0) ? ((ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Klantrecord niet gevonden voor deze partner. Klik op \u0027Partnerportaal activeren\u0027 op de partnerdetailpagina om er een aan te maken en probeer het vervolgens opnieuw.", SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false)), singleton.Zero())) : ((ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_4}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false)), (singleton.Zero()))), singleton.Delay(() => {
                            return singleton.Zero();
                        }));
                    }
                    else {
                        setCustomer(customer_3.fields[0]);
                        return singleton.Zero();
                    }
                });
            }
        }));
    }, [partnerId]);
    const pageTitle = (data.tag === 2) ? ((data.fields[0].tag === 0) ? ((data.fields[0].fields[0] != null) ? (equals(data.fields[0].fields[0].Dossier.Kind, new DossierKind(1)) ? ((dossier_1 = data.fields[0].fields[0], "EPC bewerken")) : "Dossier bewerken") : "Dossier bewerken") : "Dossier bewerken") : "Dossier bewerken";
    return createElement(Page, {
        currentPage: currentPage,
        title: pageTitle,
        actions: [],
        children: [Card([createElement(DisplayDeferred, {
            data: data,
            view: (dossier_2) => {
                if (dossier_2 == null) {
                    return createElement(ErrorText, {
                        text: `Geen Dossiers gevonden met code ${dossierCode_1}`,
                    });
                }
                else {
                    const dossier_3 = dossier_2;
                    let customer_5;
                    if (customer == null) {
                        customer_5 = dossier_3.Customer;
                    }
                    else {
                        const c = customer;
                        customer_5 = customer;
                    }
                    return createElement(EditDossierStepperPage, {
                        dossierDetails: dossier_3,
                        comments: patternInput_5[0],
                        commentType: commentType,
                        setCommentType: patternInput_6[1],
                        showInternalComments: true,
                        customerUrl: (arg_9) => Page$2__toUrl_2B594(customerDetail, arg_9),
                        dossierUrl: Page$2__toUrl_2B594(dossierDetail, dossier_3.Dossier.Code.Value),
                        getCustomer: (customerCode) => {
                            startImmediate(singleton.Delay(() => singleton.Bind(api.GetCustomer(customerCode), (_arg_1) => {
                                const customer_1 = _arg_1;
                                if (customer_1.tag === 1) {
                                    const err_1 = customer_1.fields[0];
                                    console.error(err_1);
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_1}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                    return singleton.Zero();
                                }
                                else {
                                    setCustomer(customer_1.fields[0]);
                                    return singleton.Zero();
                                }
                            })));
                        },
                        customers: customers,
                        onEditDossier: (dossierData) => ((comment) => ((sendMailToPartner) => ((onCompleted) => {
                            startImmediate(singleton.Delay(() => singleton.TryFinally(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => {
                                toConsole(printf("COMMENT %A"))(comment);
                                return singleton.Bind(api.EditDossier(dossierCode_1, dossierData, comment), (_arg_3) => {
                                    let matchValue;
                                    const result = _arg_3;
                                    if (result.tag === 0) {
                                        return singleton.Combine((matchValue = result.fields[0].AssignmentConfirmationResult, (matchValue.tag === 1) ? ((ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een nieuw dossier is aangemaakt. ${matchValue.fields[0]}`, SnackbarProp_Variant_Z609E1E86("warning"), new EnqueueSnackbarOption(1, false)), singleton.Zero())) : ((ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een nieuw dossier is aangemaakt. ${matchValue.fields[0]}`, SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false)), singleton.Zero()))), singleton.Delay(() => {
                                            RouterModule_nav(ofArray(Page$2__toUrl_2B594(dossierDetail, dossierCode_1.Value)), 1, 1);
                                            return singleton.Zero();
                                        }));
                                    }
                                    else {
                                        const err_2 = result.fields[0];
                                        console.error(err_2);
                                        ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_2}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                        return singleton.Zero();
                                    }
                                });
                            }), (_arg_4) => {
                                const e = _arg_4;
                                console.error(e);
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                return singleton.Zero();
                            })), () => {
                                onCompleted();
                            })));
                        }))),
                        onCreateCustomer: (customerData) => ((onCompleted_1) => {
                            startImmediate(singleton.Delay(() => singleton.TryFinally(singleton.Delay(() => singleton.TryWith(singleton.Delay(() => singleton.Bind(api.CreateCustomer(customerData), (_arg_5) => {
                                const result_1 = _arg_5;
                                if (result_1.tag === 0) {
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, "Een nieuwe klant is aangemaakt", SnackbarProp_Variant_Z609E1E86("success"), new EnqueueSnackbarOption(1, false));
                                    return singleton.Zero();
                                }
                                else {
                                    const err_3 = result_1.fields[0];
                                    console.error(err_3);
                                    ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${err_3}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                    return singleton.Zero();
                                }
                            })), (_arg_6) => {
                                const e_1 = _arg_6;
                                ProviderContext__enqueueSnackbar_Z1776A768(snackbar, `Een onbekende fout is opgetreden. Gelieve support te contacteren. [${e_1.message}]`, SnackbarProp_Variant_Z609E1E86("error"), new EnqueueSnackbarOption(1, false));
                                console.error(e_1);
                                return singleton.Zero();
                            })), () => {
                                onCompleted_1();
                            })));
                        }),
                        customer: customer_5,
                        customerOfPartner: void 0,
                        partnersList: patternInput_3[0],
                        setPartnerId: patternInput_4[1],
                        dossierCreatePageSource: new DossierCreatePageSource(0),
                    });
                }
            },
        })])],
    });
}

